import { useNavigate } from "react-router-dom";
import { Box } from "@mui/material";
import styled from "styled-components";
import NAV from "../utils/nav.const";
import { useEffect } from "react";

const HomePage = () => {
  const navigate = useNavigate();

  useEffect(() => {
    navigate("/" + NAV.PROPERTY_OVERVIEW);
  }, []);

  return (
    <Box display={"flex"} justifyContent={"center"} alignItems={"center"}>
    </Box>
  );
};

export default HomePage;
